import { PageHero } from "../components/common/PageHero";
import { AboutManifesto } from "../components/sections/AboutManifesto";
import { WhyFrontxGrid } from "../components/sections/WhyFrontxGrid";
import { ProcessTimeline } from "../components/sections/ProcessTimeline";
import { FinalCTA } from "../components/sections/FinalCTA";
import { Marquee } from "../components/common/Marquee";
import { images, site } from "../data/content";
import { Reveal } from "../components/common/Reveal";

export default function About() {
    return (
        <>
            <PageHero
                overline="About Us"
                breadcrumb="About"
                title="Building Workforce. Delivering Projects. Creating Impact."
                subtitle="A professionally managed manpower, staffing, workforce management and construction services company serving organizations across India."
                image={images.corporate}
            />
            <section className="bg-navy-deep text-white border-b border-white/10">
                <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-14 grid sm:grid-cols-3 gap-8">
                    {[
                        { k: "Company Type", v: site.type },
                        { k: "Business Coverage", v: site.coverage },
                        { k: "CIN", v: site.cin },
                    ].map((x) => (
                        <Reveal key={x.k}>
                            <div className="text-xs uppercase tracking-[0.2em] text-brand font-semibold">{x.k}</div>
                            <div className="mt-2 font-display font-bold text-lg">{x.v}</div>
                        </Reveal>
                    ))}
                </div>
            </section>
            <AboutManifesto withCta={false} />
            <Marquee items={["Reliable", "Professional", "Scalable", "PAN India"]} />
            <WhyFrontxGrid />
            <ProcessTimeline />
            <FinalCTA />
        </>
    );
}
